module.exports = __webpack_public_path__ + "img/rank10.d9cb547d.png";